<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>合同签订管理</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<crud :fields="fields" :select="select" :limits="limits" apiU="Contract"></crud>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fields: [
					{
						name: 'userId',
						label: '用户',
						type: 'select',
						selection: {
							data: (value)=>{
								value.splice(0,value.length);
								return this.api.user.getUserList()
								.then((response)=>{
									let val=response.data.data.list.map((v)=>{
										return {
											label: v.username,
											value: v.id.toString()
										}
									});
									value.push(...val);
								})
							},
							prop: {
								label: 'label',
								value: 'value'
							}
						},
						rule: [
							{ required: true, message: '请选择用户', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'speciesId',
						label: '物种',
						type: 'select',
						selection: {
							data: (value)=>{
								value.splice(0,value.length);
								return this.api.Species.getList()
								.then((response)=>{
									let val=response.data.data.list.map((v)=>{
										return {
											label: v.alias,
											value: v.id
										}
									});
									value.push(...val);
								})
							},
							prop: {
								label: 'label',
								value: 'value'
							}
						},
						rule: [
							{ required: true, message: '请选择物种', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'fenceId',
						label: '栅栏',
						type: 'select',
						selection: {
							data: (value)=>{
								value.splice(0,value.length);
								return this.api.Fence.getList()
								.then((response)=>{
									let val=response.data.data.list.map((v)=>{
										return {
											label: v.name,
											value: v.id.toString()
										}
									});
									value.push(...val);
								})
							},
							prop: {
								label: 'label',
								value: 'value'
							}
						},
						rule: [
							{ required: true, message: '请选择栅栏', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'name',
						label: '名称',
						type: 'string',
						rule: [
							{ required: true, message: '请输入合同名称', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'no',
						label: '编号',
						type: 'string',
						rule: [
							{ required: true, message: '请输入合同编号', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'price',
						label: '价值',
						type: 'num',
						rule: [
							{ required: true, message: '请输入价值(单位：元)', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'weight',
						label: '体重',
						type: 'string',
						rule: [
							{ required: true, message: '请输入体重', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'claimTime',
						label: '认领时间',
						type: 'date',
						rule: [
							{ required: true, message: '请选择认领时间', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'method',
						label: '喂养方法',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'attachFile',
						label: '合同文件',
						type: 'file',
						rule: [
							{ required: true, message: '请上传合同文件', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'avatar',
						label: '图片',
						type: 'image',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'images',
						label: '更多图片',
						type: 'images',
						rule: [
							{ required: true, message: '请选择用户', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'remarks',
						label: '备注',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				select: [],
				limits: {
					add: true,
					delete: true,
					edit: true,
					find: true,
					export: true,
					look: true
				}
			}
		},
		methods: {
			
		},
		filters: {
			
		},
		mounted: function () {
			
		},
		computed: {
			
		}
	}
</script>

<style scoped>
	.bread{
		margin: 15px 0px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			margin: 5px 0px;
		}
	}
</style>
